import { AlignItems, Box, Display, JustifyContent, Space } from '@gousto-internal/citrus-react'
import React from 'react'

import { DeviceType, useDeviceType } from '@library/dom'
import { Carousel } from '../../../EndlessVarietySection/Carousel'
import { LandingPageContentSections } from '../../../../tracking'
import { SupplierCard } from '../SupplierCard/SupplierCard'
import { supplierCardProps } from './supplierCarouselConfig'

const propertiesForTracking = {
  carouselSection: LandingPageContentSections.OUR_SUPPLIERS,
}

export function SupplierCarousel() {
  const deviceType = useDeviceType()
  const isMobileDevice = deviceType === DeviceType.MOBILE

  return (
    <Box
      width="100%"
      height="100%"
      display={Display.Flex}
      alignItems={AlignItems.Center}
      justifyContent={JustifyContent.FlexStart}
    >
      <Space direction="horizontal" size={4} />
      <Carousel
        carouselAreaLabel="supplierCarousel"
        options={{ align: 'start', loop: false }}
        showNavButtons={!isMobileDevice}
        autoHideNavButtons
        slidePaddingH={2}
        snowplowTrackingProperties={propertiesForTracking}
      >
        {supplierCardProps.map((supplierCard, index) => (
          <Box key={`${supplierCard.supplierDetails.title}-${index}`}>
            <SupplierCard {...supplierCard} />
          </Box>
        ))}
      </Carousel>
    </Box>
  )
}
